export default __webpack_public_path__ + "static/media/phone.f0f24e1d.svg";